import { AutogenLayoutSettlementCheckReport } from "./autogen/AutogenLayoutSettlementCheckReport";

export class SettlementCheckReport extends AutogenLayoutSettlementCheckReport {
    override onLoad(): void {
        this.textboxVoidedStatus.selectedItem = this.textboxVoidedStatus.items[0];
        this.textboxClearedStatus.selectedItem = this.textboxClearedStatus.items[0];
    }
}
